import { render, staticRenderFns } from "./CallRecordTable.vue?vue&type=template&id=231a7368&scoped=true"
import script from "./CallRecordTable.vue?vue&type=script&lang=js"
export * from "./CallRecordTable.vue?vue&type=script&lang=js"
import style0 from "./CallRecordTable.vue?vue&type=style&index=0&id=231a7368&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a7368",
  null
  
)

export default component.exports